"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./index.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Node
// Style
var Wrapper = function Wrapper(_ref) {
  var children = _ref.children,
      className = _ref.className,
      type = _ref.type,
      noPadding = _ref.noPadding,
      style = _ref.style;
  // Label Modifier
  var typeClass = '';
  var noPaddingClass = noPadding ? 'shpmtc-wrapper--no-padding' : '';

  switch (type) {
    case 'Full':
      typeClass = "shpmtc-wrapper--full ".concat(noPaddingClass);
      break;

    case 'Large':
      typeClass = "shpmtc-wrapper--large ".concat(noPaddingClass);
      break;

    case 'Med':
      typeClass = "shpmtc-wrapper--medium ".concat(noPaddingClass);
      break;

    case 'Small':
      typeClass = "shpmtc-wrapper--small ".concat(noPaddingClass);
      break;

    default:
      typeClass = "shpmtc-wrapper--default ".concat(noPaddingClass);
      break;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "\n        shpmtcd\n        shpmtc-wrapper\n        ".concat(typeClass, "\n        ").concat(className, "\n      "),
    style: style
  }, children);
}; // Prop Types


exports.Wrapper = Wrapper;
Wrapper.defaultProps = {
  children: null,
  className: '',
  type: '',
  noPadding: false,
  style: null
};
Wrapper.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  type: _propTypes.default.string,
  noPadding: _propTypes.default.bool,
  style: _propTypes.default.string
};